var map = {
	"./auth/auth.module": [
		"./src/app/content/pages/auth/auth.module.ts",
		"default~app-content-pages-pages-module~auth-auth-module~components-dashboard-dashboard-module",
		"common",
		"auth-auth-module"
	],
	"./components/dashboard/dashboard.module": [
		"./src/app/content/pages/components/dashboard/dashboard.module.ts",
		"default~app-content-pages-pages-module~auth-auth-module~components-dashboard-dashboard-module",
		"default~app-content-pages-pages-module~components-dashboard-dashboard-module",
		"common",
		"components-dashboard-dashboard-module"
	],
	"app/content/pages/pages.module": [
		"./src/app/content/pages/pages.module.ts",
		"default~app-content-pages-pages-module~auth-auth-module~components-dashboard-dashboard-module",
		"default~app-content-pages-pages-module~components-dashboard-dashboard-module",
		"common",
		"app-content-pages-pages-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;